import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './AxiosBaseQuery';
import { V3_APP_BASE_URL } from '@/constants/Config';

export interface IProductFilterRes {
  id: number;
  types: string;
  brands: string;
  styles: string;
  price: string;
  made_for: string;
  seasons: string;
  colors: string;
}

export interface IDesignFilterRes {
  id: number;
  organizations: string;
  events: string;
  styles: string;
  great_for: string;
}

export const filterQuery = createApi({
  reducerPath: 'filterQuery',
  baseQuery: axiosBaseQuery({
    baseUrl: V3_APP_BASE_URL,
  }),
  tagTypes: ['DesignFilter', 'ProductFilter'],
  endpoints: (build) => ({
    getFilters: build.query<IDesignFilterRes[] | IProductFilterRes[], boolean>({
      query: (fetchDesign: boolean) => ({
        url: 'api/cp/fp-filters',
        method: 'get',
        params: {
          fetchDesign,
        },
      }),
      providesTags: (_result, _error, fetchDesign) =>
        fetchDesign ? ['DesignFilter'] : ['ProductFilter'],
      transformResponse: (response: IDesignFilterRes[] | IProductFilterRes[]) => response,
    }),
  }),
});

export const { useGetFiltersQuery } = filterQuery;
